import React from 'react';

import { isEmpty } from 'lib/helpers/utility';

const OrderPhysician = ({ itemProps }) => {
  const hasNoOrderNpi = isEmpty(
    itemProps?.provider?.practitionerClaimMdInfo?.npi || itemProps?.order_phys_npi
  );
  const hasNoOrderFName = isEmpty(itemProps?.provider?.f_name || itemProps?.order_phys_first);
  const hasNoOrderLName = isEmpty(itemProps?.provider?.l_name || itemProps?.order_phys_last);
  const hasNoOrderPhone = isEmpty(itemProps?.provider?.phone);
  const hasNoOrderAltPhone = isEmpty(itemProps?.provider?.alt_phone);
  const hasNoOrderEmail = isEmpty(itemProps?.provider?.email);

  if (
    hasNoOrderFName &&
    hasNoOrderLName &&
    hasNoOrderNpi &&
    hasNoOrderPhone &&
    hasNoOrderAltPhone &&
    hasNoOrderEmail
  ) {
    return null;
  }

  const firstName = itemProps?.order_phys_first || itemProps?.provider?.f_name || '';
  const lastName = itemProps?.order_phys_last || itemProps?.provider?.l_name || '';
  const npi = itemProps?.order_phys_npi || itemProps?.provider?.practitionerClaimMdInfo?.npi || '';
  const phone = itemProps?.provider?.phone || '';
  const altPhone = itemProps?.provider?.alt_phone || '';
  const email = itemProps?.provider?.email || '';

  return (
    <div>
      <div className="text-base font-500 text-neutral-800">Order Physician</div>

      <ul className="!mt-3 !pl-5">
        <li className="!list-outside list-disc whitespace-pre-wrap break-normal text-sm">
          {!isEmpty(firstName) && (
            <div>
              <strong>First Name:</strong> {firstName}
            </div>
          )}

          {!isEmpty(lastName) && (
            <div>
              <strong>Last Name:</strong> {lastName}
            </div>
          )}

          {!isEmpty(npi) && (
            <div>
              <strong>NPI:</strong> {npi}
            </div>
          )}

          {!isEmpty(phone) && (
            <div>
              <strong>Phone:</strong> {phone}
            </div>
          )}

          {!isEmpty(altPhone) && (
            <div>
              <strong>Alt Phone:</strong> {altPhone}
            </div>
          )}

          {!isEmpty(email) && (
            <div>
              <strong>Email:</strong> {email}
            </div>
          )}
        </li>
      </ul>
    </div>
  );
};

export default OrderPhysician;
